const announcementTypes: {
  name:
    | '置頂'
    | '規約'
    | '一般'
    | '活動'
    | '會議'
    | '財務'
    | '維修保養'
    | '系統'
    | '檔案'
    | '其他'
    | '管理辦法';
  color: string;
}[] = [
  { name: '置頂', color: '#B97840' },
  { name: '規約', color: '#69B49E' },
  { name: '一般', color: '#75ADD0' },
  { name: '活動', color: '#44917B' },
  { name: '會議', color: '#0063A0' },
  { name: '財務', color: '#9F5281' },
  { name: '維修保養', color: '#5A60AF' },
  { name: '系統', color: '#9F5252' },
  { name: '檔案', color: '#C3AE6A' },
  { name: '其他', color: '#B4B4B9' },
  { name: '管理辦法', color: '#C3AE6A' },
];

export { announcementTypes };
